/** @format */
console.log("main page script loaded");
import React from "react";
import { render } from "react-dom";
import MainPage from "./React/layout/MainPage";

const mainEl = document.querySelector('[data-react-entrypoint="mainentry"]') || null;
const mainInit = (el) => {
	const collectionHandle = el.dataset.collectionHandle
	const collectionObj = el.dataset.collectionObj
	const collectionLength = el.dataset.collectionLength

	render(<MainPage
		collectionHandle={collectionHandle}
		collectionObj={collectionObj}
		collectionLength={collectionLength}
	>
</MainPage>,
		el
	)
};

if (mainEl) {
	mainInit(mainEl);
}
